import { Component, ChangeDetectionStrategy, computed, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'bodyanalytics-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  imports: [MatProgressSpinnerModule],
  host: { '[class.fullscreen]': 'fullscreen()' },
})
export class LoadingSpinnerComponent {
  spinnerTitle = input<string>();

  /**
   * Route / page-level loads: when true the spinner reserves a tall content area
   * (min-height) so it centers in the viewport instead of clinging to the top.
   * Leave false (default) for inline / in-card loads. Fixes the customer dashboard
   * top-float — the loader used to delegate vertical centering to each caller.
   */
  fullscreen = input(false);

  /**
   * Accessible name for the indeterminate progressbar. Falls back to a sensible
   * default so the spinner is never an anonymous `role="progressbar"` (axe
   * `aria-progressbar-name`, see #1212). The visible heading still uses the raw
   * `spinnerTitle()` value when one is supplied.
   */
  readonly accessibleLabel = computed(() => this.spinnerTitle() ?? 'Loading');
}
